import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AnnouncementBar extends ThemeComponent {
    @Ref closeBtn!: HTMLButtonElement;

    init() {
        this.initEvents();
        this.checkCookie();
    }

    private checkCookie() {
        const cookieValue = this.getCookieValue('announcement');
        if (cookieValue !== 'off') {
            this.style.display = 'block';
            document.body.classList.add('announcement-bar-active');
        }
    }

    private getCookieValue(name: string) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {return parts.pop()?.split(';').shift();}
    }

    private initEvents() {
        this.$listen(this.closeBtn, 'click', () => {
            document.cookie = `announcement=off; path=/; max-age=${60 * 60 * 24 * 7};`;
            this.style.display = 'none';
            document.body.classList.remove('announcement-bar-active');
        });
    }
}
